import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, Paper} from 'views/components';
import {SummarizeOutlined as SummarizeIcon} from 'views/icons';
import {MarkdownViewer, Translate, translate} from 'views/module';

const CareplanSummary = (props) => {
  const {careplanSummary} = props;

  return (
    <Paper
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 2,
          py: 1,
          backgroundColor: 'grey.100',
          justifyContent: 'space-between',
          borderRadius: '4px 4px 0 0',
          width: '100%',
        }}
      >
        <Box sx={{display: 'flex', alignItems: 'center'}}>
          <SummarizeIcon sx={{mr: 1}} />
          <Typography variant="h6">
            <Translate expression="loomLead.LoomLeadDetail.Careplan.CareplanSummary.Title" />
          </Typography>
        </Box>
      </Box>
      <Box sx={{p: 2}}>
        <MarkdownViewer
          value={careplanSummary || translate('loomLead.LoomLeadDetail.Careplan.CareplanSummary.NoCareplanSummary')}
          truncate={true}
        />
      </Box>
    </Paper>
  );
};

CareplanSummary.propTypes = {
  careplanSummary: PropTypes.string,
};

export default CareplanSummary;
